import { render, staticRenderFns } from "./areaAppealDetail.vue?vue&type=template&id=1b02170a&scoped=true"
import script from "./areaAppealDetail.vue?vue&type=script&lang=js"
export * from "./areaAppealDetail.vue?vue&type=script&lang=js"
import style0 from "./areaAppealDetail.vue?vue&type=style&index=0&id=1b02170a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b02170a",
  null
  
)

export default component.exports